<div class="component-container">
 
  <ng-container> 
    <ng-container *ngIf="page.data.length === 0">
      <div class="no-taken-yards">
          <p>No available trailers to be moved! Only yard locations in the occupied status can be moved!</p>
      </div>
    </ng-container>
    <ng-container *ngIf="page.data.length > 0">
       <div class="assignment-screen">
    <section class="spot-list">
      <section class="component-header">
         <h2>Taken Spots</h2>
      </section>
     
      <div
        class="spot-list-border"
      >
        <section
          class="target-spots"
          *ngFor="let yard of page.data; let i = index;"
        >
          <div class="location-card">
            <div class="card-header">
              <div class="location-title">
                <h2 class="location-name"><strong>Spot: </strong>{{ yard.location }}</h2>
              </div
              >
            </div>
            <div class="objects-section">
              <section class="info-wrapper">
                <p>
                  <strong>Trailer Number: </strong
                  >{{ yard?.trailer?.trailer ?? "no data" }}
                </p>
                <p>
                  <strong>Carrier: </strong
                  >{{ yard?.trailer?.carrier ?? "no data" }}
                </p>
                <p><strong>Status: </strong>{{ yard?.status ?? "no data" }}</p>
              </section>
              <section class="btn-wrapper">
                <assign-form
                  [openYardSpots]="openYardSpots"
                  [targetStartYard]="yard"
                  (targetEndYard)="formAssignMove($event, i)"
                ></assign-form>
              </section>
            </div>
          </div>
        </section>
        <mat-paginator #paginator
          *ngIf="page?.data?.length !== 0"
          (page)="handlePageEvent($event)"
          [length]="page.totalItems"
          [pageSize]="searchParams.size"
          [showFirstLastButtons]="true"
          [pageSizeOptions]="pageSizeOptions"
          [pageIndex]="page.currentPage"
          aria-label="Select page">
        </mat-paginator>
      </div>

    </section>
    <!---->
  </div>
    </ng-container>

</ng-container>
</div>
